module.exports = __webpack_public_path__ + "static/media/21.9d85a62c.jpg";